import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "react-toastify";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { GET_USER_BRANDING_QUERY_KEY } from "./useGetUserBranding";

type UploadImageFields = "agentAvatar" | "officeLogo" | "teamLogo";

type Props = {
  onSuccess?: (data: string) => void;
  field: UploadImageFields;
};

type Params = {
  file: Blob;
};

export const useUpdateUserBrandingImage = (props: Props) => {
  const { onSuccess, field } = props;
  const queryClient = useQueryClient();
  const api = getUsersApiClient();
  const mutation = useMutation({
    mutationFn: async ({ file }: Params) => {
      const response = await api.userControllerUpdateBrandingImage({
        file,
        field,
      });
      onSuccess?.(response);
      queryClient.invalidateQueries({
        queryKey: [GET_USER_BRANDING_QUERY_KEY],
      });
      return response;
    },
    onError: async (error) => {
      console.error("Failed to upload image", error);
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0], {
          toastId: "upload-branding-image-error",
        });
        return;
      }
      toast.error("Error uploading image", {
        toastId: "upload-branding-image-error",
      });
    },
  });

  return mutation;
};
